import { render, staticRenderFns } from "./MassCampaigns.vue?vue&type=template&id=e35ab114&scoped=true&"
import script from "./MassCampaigns.vue?vue&type=script&lang=js&"
export * from "./MassCampaigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35ab114",
  null
  
)

export default component.exports